module.exports = __webpack_public_path__ + "img/COVID-19-Livelihood-650x340.5c9b9d45.png";